import "./App.css";
import "./assets/css/St-style.css";
import "./assets/css/Chat.css";
import "./assets/css/Style.css";
import "./assets/css/Review.css";
// import "react-calendar/dist/Calendar.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import BasicRoutes from "./Routes/BasicRoutes";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";

function App() {
    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <BasicRoutes />
            </PersistGate>
        </Provider>
    );
}

export default App;
